export type UploadFilePreviewKind = 'image' | 'pdf' | 'json' | 'unsupported';

export function getUploadFilePreviewKind(fileName: string): UploadFilePreviewKind {
  const ext = fileName.split('.').pop()?.toLowerCase() ?? '';
  if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'].includes(ext)) {
    return 'image';
  }
  if (ext === 'pdf') {
    return 'pdf';
  }
  if (ext === 'json') {
    return 'json';
  }
  return 'unsupported';
}

export function isUploadFilePreviewable(fileName: string): boolean {
  return getUploadFilePreviewKind(fileName) !== 'unsupported';
}

/** Encode S3/file URLs so spaces and special characters load correctly in preview. */
export function encodeFilePreviewUrl(url: string): string {
  const trimmed = String(url || '').trim();
  if (!trimmed) {
    return '';
  }

  try {
    const parsed = new URL(trimmed);
    parsed.pathname = parsed.pathname
      .split('/')
      .map((segment) => {
        if (!segment) {
          return segment;
        }
        try {
          return encodeURIComponent(decodeURIComponent(segment));
        } catch {
          return encodeURIComponent(segment);
        }
      })
      .join('/');
    return parsed.toString();
  } catch {
    return encodeURI(trimmed);
  }
}

export function buildGooglePdfViewerUrl(url: string): string {
  const encoded = encodeFilePreviewUrl(url);
  return `https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(encoded)}`;
}
